import config from '@/config';
import { ENV_MISSING } from '@/config/config';
import { rootLogger } from '@/util/logger';

export default function logAppConfig() {
    const envString = JSON.stringify(config);
    const level = envString.includes(ENV_MISSING) ? 'error' : 'info';
    rootLogger[level](
        { config },
        `ENV: ${config.app.env}, VERSION: ${config.app.version}, PLATFORM/ID: ${config.app.platform}/${config.app.platformId}`,
    );
}
